"use client";
import * as React from "react";
const SvgShoppingCartOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.636 8.8c.6 0 1.127-.328 1.4-.824l2.862-5.192a.797.797 0 0 0-.696-1.184H3.367L2.615 0H0v1.6h1.6l2.878 6.072-1.08 1.952C2.816 10.696 3.584 12 4.799 12h9.597v-1.6H4.798l.88-1.6h5.958Zm-7.51-5.6h9.717l-2.207 4H6.022l-1.896-4Zm.672 9.6c-.88 0-1.591.72-1.591 1.6 0 .88.712 1.6 1.591 1.6.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6Zm7.997 0c-.88 0-1.591.72-1.591 1.6 0 .88.712 1.6 1.591 1.6.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6Z" }));
export {
  SvgShoppingCartOutlined as default
};
